<template>
  <div class="question-card" :class="cardClass">
    <div class="question-card__title" :class="titleClass">
      <div v-html="title"></div>
      <div v-if="hasIcon"><Icon :name="iconName" size="xl" /></div>
      <div v-if="state === 'paid'"><img :src="coinImage" /></div>
    </div>
    <div class="question-card__detail">
      <div
        v-for="(item, i) in items"
        :key="i"
        class="detail__item"
      >
        <Radio
          v-model="selectedValue"
          :value="i"
          @input="onChanged"
          :disabled="isItemDisabled(i)"
        >
          {{ item.text }}
        </Radio>
      </div>
    </div>
  </div>
</template>

<script>
import Radio from '@rr-component-library/radio/src/main';
import Icon from '@rr-component-library/icon/src/main';
import Coin from '../assets/img/coin.svg';

export default {
  name: 'QuestionCard',
  designVersion: '1.0.0',
  components: {
    Radio,
    Icon,
  },
  props: {
    title: String,
    items: Array,
    selectedItem: Number,
    state: {
      type: String,
      default: 'general',
      validator(value) {
        return ['', 'general', 'paid', 'error', 'success'].indexOf(value) !== -1;
      },
    },
  },
  data() {
    return {
      selectedValue: null,
      coinImage: Coin,
    };
  },
  computed: {
    cardClass() {
      return `question-card_${this.state || ''}`;
    },
    titleClass() {
      return `question-card__title_${this.state || ''}`;
    },
    hasIcon() {
      return this.state === 'success' || this.state === 'error';
    },
    iconName() {
      if (this.state === 'success') return 'check-circle-s';
      if (this.state === 'error') return 'close-circle-s';
      return '';
    },
  },
  methods: {
    onChanged() {
      this.$emit('changed', this.selectedValue);
    },
    isItemDisabled(index) {
      if (this.state && this.state !== 'general' && this.state !== 'paid' 
        && this.selectedValue !== index) return true;
      return false;
    },
  },
  mounted() {
    if (this.selectedItem !== undefined && this.selectedItem >= 0 && this.selectedItem < this.items.length) {
      this.selectedValue = this.selectedItem;
    }
  },
};
</script>

<style lang="scss" scoped>
  @import './QuestionCard';
</style>
